import gtmTrackUserTraits from 'packages/@crunchyroll/analytics/gtm';

function gtmTrackUserReady() {
  return (_, getState) => {
    // for a non logged in user, there is no email, so set to empty string
    const { user } = getState();
    const emailString = user?.email || '';

    return gtmTrackUserTraits({ email: emailString });
  };
}

export { gtmTrackUserReady };
